import { c as _c } from "react/compiler-runtime";
import { FUNNELS_API } from 'modules/funnels/api/funnels-api';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import useSWR from 'swr';
export interface FunnelStepDataInterface {
  bumpsCount: number;
}
export function useFunnelStepData() {
  const $ = _c(6);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== user) {
    t1 = () => {
      if (user) {
        return `${FUNNELS_API}/step/data`;
      }
      return null;
    };
    $[1] = user;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data: funnelStepData,
    mutate: mutateFunnelStepData
  } = useSWR(t1, fetcher);
  let t2;
  if ($[3] !== funnelStepData || $[4] !== mutateFunnelStepData) {
    t2 = {
      funnelStepData,
      mutateFunnelStepData
    };
    $[3] = funnelStepData;
    $[4] = mutateFunnelStepData;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}